import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../jsx/global-functions/checkErrors";
export const makeLangDefaultFunc = createAsyncThunk(
    "make lang default function",
    async ({api , data}) => {
        const token = window.localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}` // Include the token in the Authorization header
            }
        }
        try {
            const response = await axios.post(api , data ,  config);
            return response.data;
        }
        catch (error) {
            checkErrors(error.response , error.message);
        }
        
    }
)

const makeLangDefaultSlicer = createSlice({
    name : "make lang default slicer",
    initialState : {
        loading : null,
        data : null,
        error : null
    },
    reducers : {},
    extraReducers : (builder) => {
        builder.addCase(makeLangDefaultFunc.pending , (state) => {
            state.loading = true
            state.data = false
            state.error = false
        });
        builder.addCase(makeLangDefaultFunc.rejected , (state) => {
            state.loading = false
            state.data = null
            state.error = true
        });
        builder.addCase(makeLangDefaultFunc.fulfilled , (state , action) => {
            state.loading = null
            state.data = action.payload
            state.error = null
        });
    }
});

export default makeLangDefaultSlicer.reducer;